import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import NoticeModal from "views/components/NoticeModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../../components/UpdateUi/CustomeSelect";

const WeighageControllerCreate = ({
  classes,
  WeighageAllocationShow,
  weighageId,
  setWeighageId,
  onClose,
  rawData,
}) => {
  const navigate = useNavigate();
  const [weighage, setWeighage] = useState("");
  const [weighageState, setWeighageState] = useState(false);
  const [param, setParam] = useState("");
  const [paramState, setParamState] = useState(false);
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [isValid, setIsValid] = useState(true);

  const [callInProgress, setCallInProgress] = useState(false);
  const paramList = [
    { code: "CIBIL", name: "CIBIL" },
    { code: "SALARY", name: "SALARY" },
    { code: "DURATION IN CURRENT COMPANY", name: "DURATION IN CURRENT COMPANY" },
    { code: "APPLICANT AGE", name: "APPLICANT AGE" },
  ];
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (param === "") {
      setParamState(true);
    } else {
      setParamState(false);
    }
    if (weighage === "") {
      setWeighageState(true);
    } else {
      setWeighageState(false);
    }
    if (weighage === "" || param === "") {
      setIsValid(false)
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (weighageId) {
      GetData();
    }
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_CONTROLLER_FIND_BY_ID + weighageId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      setNoticeModalErrMsg(result?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setWeighage(result?.data?.weightage);
      setParam(result?.data?.param);
    }
  };

  const handleCreateSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.MASTER_WEIGHTAGE_CONTROLLER_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          param: param,
          weightage: parseInt(weighage),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        setNoticeModalErrMsg(res?.data?.user_description);
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        return;
      } else {
        onClose("create");
        WeighageAllocationShow(true);
      }
    }
  };

  const handleEditSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.MASTER_WEIGHTAGE_CONTROLLER_UPDATE + weighageId,
        method: "PUT",
        authToken: authToken,
        data: {
          param: param,
          weightage: parseInt(weighage),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        setNoticeModalErrMsg(res?.data?.user_description);
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        return;
      } else {
        onClose("update");
        WeighageAllocationShow(true);
      }
    }
  };
  const handleCancel = () => {
    WeighageAllocationShow(true);
    setWeighageId("");
  };

  const handleInputChange = (e,name) => {
    const enteredValue = e;
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            weighageId ? "Edit Weightage" : "Create Weightage"
          }
          button1=" Save"
          button2=" Cancel"
          button1click={weighageId ? handleEditSubmit : handleCreateSubmit}
          button2click={handleCancel}
          // disabled1={isValid}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes?.inputContainer}>
        <Grid container className={classes?.inputFieldContainer}>
          <Grid xs={12} sm={12} md={4} className={classes?.fieldContaienr}>
            <CustomSelectNew
              label="Param*"
              error={paramState}
              value={param}
              setState={setParam}
              data={paramList}
              setError={setParamState}
              type = "newSchemeCharge"
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className={classes?.fieldContaienr}>
            <CustomTextField
              label="Weightage"
              required
              error={weighageState}
              id="lp_branch_code"
              value={weighage || ""}
              setState={setWeighage}
              setError={setWeighageState}
              setBlur={!isValid}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
    </Grid>
  );
};

WeighageControllerCreate.propTypes = {
  classes: PropTypes.object,
};

export default WeighageControllerCreate;
